import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["value"]

import { ref } from 'vue';
import { usePrinters } from '@/storecontext/shared/printers/usePrinters';
import InputSelect from '@/shared/form/InputSelect.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PrinterSelector',
  props: {
    label: null,
    usePrinterName: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    label: string,
    usePrinterName: boolean
}



const { printers, defaultPrinter } = usePrinters(props.usePrinterName);
const selectedPrinter = ref(defaultPrinter);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InputSelect, {
    modelValue: selectedPrinter.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedPrinter).value = $event)),
    name: "printer",
    label: __props.label,
    "show-errors": false
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(printers), (printer) => {
        return (_openBlock(), _createElementBlock("option", {
          key: printer.id,
          value: __props.usePrinterName ? printer.name : printer.id
        }, _toDisplayString(printer.name), 9, _hoisted_1))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue", "label"]))
}
}

})